export default __webpack_public_path__ + "static/media/mobile.f6fb92d6.svg";